import * as React from 'react'
import { cn } from '@/lib/utils'

type IconButtonVariant = 'surface' | 'ghost' | 'primary' | 'ghostPrimary'
type IconButtonSize = 'md' | 'lg'

export interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: IconButtonVariant
  size?: IconButtonSize
}

const variantClasses: Record<IconButtonVariant, string> = {
  surface:
    'bg-white text-gray-700 shadow-md hover:bg-gray-100 active:bg-primary active:text-primary-foreground disabled:opacity-60 disabled:cursor-not-allowed',
  ghost: 'text-slate-700 hover:bg-slate-100 active:bg-slate-200 disabled:opacity-50',
  primary:
    'bg-primary text-primary-foreground shadow-md hover:bg-primary/90 active:bg-primary-active disabled:opacity-60 disabled:cursor-not-allowed',
  ghostPrimary: 'text-primary hover:bg-primary/10 active:bg-primary/15 disabled:opacity-50',
}

const sizeClasses: Record<IconButtonSize, string> = {
  md: 'h-10 w-10',
  lg: 'h-12 w-12',
}

export const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(
  { className, variant = 'ghost', size = 'md', type = 'button', ...props },
  ref
) {
  return (
    <button
      ref={ref}
      type={type}
      className={cn(
        'inline-flex items-center justify-center rounded-lg border-0 cursor-pointer transition-[transform,colors,box-shadow] active:scale-[0.97] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/35 focus-visible:ring-offset-2 focus-visible:ring-offset-white disabled:pointer-events-none',
        sizeClasses[size],
        variantClasses[variant],
        className
      )}
      {...props}
    />
  )
})
